<template>
  <div class="wlx-apply-table-wrapper">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
      <div class="basic-head-con">
        <div class="head-title-con clearfix">
          <div class="fl basic-book-img-con">
            <img src="~assets/images/basic-book-img.png" alt />
          </div>
          <div class="fr head-title-word">
            <p class="p-title-1">考试报名申请表</p>
            <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
          </div>
        </div>
      </div>
    </div>
    <div class="apply-table-content">
      <table border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td colspan="2" class="u-label-title">申报学校</td>
          <td colspan="2">
           {{schoolName}}
          </td>

           <td colspan="1" class="u-label-title">报考人数</td>
          <td colspan="1">
           <el-input v-model="enrolmentCount"></el-input>
          </td>
        </tr>
        <tr>
          <td class="u-label-title" colspan="2" rowspan="5">考试安排</td>
          <td class="u-label-title" colspan="3">选择考试时间</td>
          <td class="u-label-title" colspan="1">剩余人数</td>
        </tr>
         <tr>
          <td colspan="3" class="u-label-title">
             <el-radio v-model="radio" :label="1" @change="surplusNumber" class="u-label-title">2019-11-16 ~ 2019-11-17</el-radio>
            
          </td>
           <td colspan="1" class="u-label-title">
             {{firstCount}}
           </td>
        </tr>
        <tr>
          <td colspan="3" class="u-label-title">
            <el-radio v-model="radio" :label="2" @change="surplusNumber" class="u-label-title">2019-11-23 ~ 2019-11-24</el-radio>
            
          </td>
           <td colspan="1" class="u-label-title">
             {{secondCount}}
           </td>
        </tr>
        <tr>
          <td colspan="3" class="u-label-title">
            <el-radio v-model="radio" :label="3" @change="surplusNumber"  class="u-label-title" >2019-11-30 ~ 2019-12-01</el-radio>
            
          </td>
           <td colspan="1" class="u-label-title">
             {{thirdCount}}
           </td>
        </tr>
        <tr>
          <td colspan="3" class="u-label-title">
            <el-radio v-model="radio" :label="4" @change="surplusNumber"  class="u-label-title" >2019-12-07 ~ 2019-12-08</el-radio>
          </td>
           <td colspan="1" class="u-label-title">
             {{fourthCount}}
           </td>
        </tr>

         <tr>
          <td colspan="2" class="u-label-title"></td>
          <td colspan="2" class="u-label-title">姓名</td>
           <td colspan="2" class="u-label-title"> 联系方式</td>
        </tr>
        <tr>
          <td colspan="2" class="u-label-title">总负责人</td>
          <td colspan="2">
            <el-input v-model="zname"></el-input>
          </td>
           <td colspan="2">
            <el-input v-model="zphone"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="u-label-title">实训场地管理员</td>
          <td colspan="2">
            <el-input v-model="sname"></el-input>
          </td>
           <td colspan="2">
            <el-input v-model="sphone"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="u-label-title">考务管理员</td>
          <td colspan="2">
            <el-input v-model="kname"></el-input>
          </td>
           <td colspan="2">
            <el-input v-model="kphone"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="u-label-title">报名管理员</td>
          <td colspan="2">
            <el-input v-model="bname"></el-input>
          </td>
           <td colspan="2">
            <el-input v-model="bphone"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="u-label-title">机房管理员</td>
          <td colspan="2">
            <el-input v-model="jname"></el-input>
          </td>
           <td colspan="2">
            <el-input v-model="jphone"></el-input>
          </td>
        </tr>
     
         <tr>
          <td colspan="2" class="u-label-title">手持型号及数量</td>
          <td colspan="4">
            <el-input v-model="handheldModel"></el-input>
          </td>
        </tr>
   
      </table>
      <div class="submit-apply-btn">
        <el-button type="primary" @click="goback">返回</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import avatarUpload from "components/avatarUpload.vue";

export default {
  data() {
    return {
      radio: 0,
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      firstCount:5000,
      secondCount:10000,
      thirdCount:10000,
      fourthCount:10000,
      examtCount:"",
      enrolmentCount: 0,
      zname:"",
      zphone:"",
      sname:"",
      sphone:"",
      kname:"",
      kphone:"",
      bname:"",
      bphone:"",
      jname:"",
      jphone:"",
      examDate:"",
      handheldModel:"",
      schoolName:""
    };
  },
  props: {
    examId:{
      type: String,
      default:""
    }
  },
  components: {
  },
  created() {
    this.getMeetingEnrollInfo();
  },
  methods: {
    surplusNumber(){
      if(this.radio == 1 || this.radio ==2 || this.radio ==3 || this.radio == 4){
      if(this.enrolmentCount<=0){
        this.$message.warning('报考人数超出该时间段剩余人数！');
      }
      }
    },
    //获取报名详情
    getMeetingEnrollInfo(){
      var that = this;
      this.$http
        .post("/api/XOrg/ExamSingUpManager/getMeetingEnrollInfo", {
          id: that.examId
        })
        .then(rst => {
          
          that.firstCount = rst.countOne;
          that.secondCount = rst.countTow;
          that.thirdCount = rst.countThree;
          that.fourthCount = rst.countFour;
          that.radio = rst.info.SingUpTime;
          that.enrolmentCount = rst.info.StudentNumber;
          that.zname = rst.info.ExamMainName;
          that.zphone = rst.info.ExamMainPhone;
          that.sname = rst.info.ExamPlaceName;
          that.sphone = rst.info.ExamPlacePhone;
          that.kname = rst.info.ExaminationName,
          that.kphone = rst.info.ExaminationPhone,
          that.bname = rst.info.SchoolSingUpName;
          that.bphone = rst.info.SchoolSingUpPhone;
          that.jname = rst.info.ExamRoomMangerName;
          that.jphone = rst.info.ExamRoomMangerPhone;
          that.handheldModel = rst.info.PDAType;
          that.schoolName = rst.info.SchoolName;
        });
    },
    getSurplusNumber(){
       var that = this;
      this.$http.post("/api/XOrg/ExamSingUpManager/getSurplusNumber",{
      }).then(function(rst) {
        if (rst.code > 0) {
          that.firstCount = rst.countOne;
          that.secondCount = rst.countTow;
          that.thirdCount = rst.countThree;
          that.fourthCount = rst.countFour;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },

    //返回
    goback(){
      this.$router.go(-1);
    },

  submit(){
    var that = this;
      if (this.enrolmentCount == 0) {
        this.$message.warning("请输入报考人数");
        return false;
      }
       if (this.radio == '') {
        this.$message.warning("请选择考试时间");
        return false;
      }
       if (this.zname == "") {
        this.$message.warning("请输入总负责人姓名");
        return false;
      }
       if (this.zphone == "") {
        this.$message.warning("请输入总负责人联系方式");
        return false;
      }
       if (this.sname == "") {
        this.$message.warning("请输入实训场地管理员姓名");
        return false;
      }
       if (this.sphone == "") {
        this.$message.warning("请输入实训场地管理员联系方式");
        return false;
      }
       if (this.kname == "") {
        this.$message.warning("请输入考务管理员姓名");
        return false;
      }
       if (this.kphone == "") {
        this.$message.warning("请输入考务管理员联系方式");
        return false;
      }
      if (this.bname == "") {
        this.$message.warning("请输入报名管理员姓名");
        return false;
      }
      if (this.bphone == "") {
        this.$message.warning("请输入报名管理员联系方式");
        return false;
      }
      if (this.jname == "") {
        this.$message.warning("请输入机房管理员姓名");
        return false;
      }
      if (this.jphone == "") {
        this.$message.warning("请输入机房管理员联系方式");
        return false;
      }
      if (this.handheldModel == "") {
        this.$message.warning("请输入手持型号及数量");
        return false;
      }
      this.$http.post("/api/XOrg/ExamSingUpManager/updateInfo",{
          Id :this.examId,
          StudentNumber:this.enrolmentCount,
          SingUpTime :this.radio,
          ExamMainPhone:this.zphone,
          ExamMainName:this.zphone,
          ExamPlacePhone:this.sphone,
          ExamPlaceName:this.sname,
          ExaminationPhone:this.kphone,
          ExaminationName:this.kname,
          SchoolSingUpPhone:this.bphone,
          SchoolSingUpName:this.bname,
          ExamRoomMangerPhone:this.jphone,
          ExamRoomMangerName:this.jname,
          PDAType:this.handheldModel
      }).then(function(rst) {
        if (rst.code > 0) {
          that.$message.success(rst.msg);
           that.$router.push({
           name: "examDeclare",
         });
        } else {
          that.$message.warning(rst.msg);
          that.getSurplusNumber();
         }
      });
  }
  }
};
</script>

<style lang="scss">
.wlx-apply-table-wrapper {
  height: 100%;
  overflow: auto;
  background: #f0f6ff;
  .basic-head-main {
    height: 706px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
    .basic-head-con {
      margin: 0 auto;
      width: 1000px;
    }
    .head-logo-con {
      padding: 26px 0 0 26px;
    }
    .logo-img-val {
      height: 40px;
    }
    .head-title-con {
      position: relative;
      padding-top: 40px;
    }
    .basic-book-img-con {
      margin-left: 10px;
    }
    .head-title-word {
      position: absolute;
      right: 0;
      top: 80px;
      z-index: 100;
      color: #fff;
    }
    .p-title-1 {
      font-size: 55px;
      font-weight: bold;
      text-align: center;
    }
    .p-title-2-1 {
      margin-top: 50px;
      text-align: right;
      font-size: 20px;
    }
  }
  .apply-table-content {
    margin: -325px auto 0;
    padding: 20px 0;
    padding-top: 50px;
    width: 1000px;
    background: #fff;
  }
  .p-down-applyTable-btn {
    text-align: right;
    color: #0365f5;
    padding: 0 22px 20px 0;
    cursor: pointer;
    font-size: 17px;
  }
  .apply-table-title {
    padding: 20px 0;
    text-align: center;
  }
  .submit-apply-btn {
    padding: 20px 0;
    text-align: center;
  }
  .label-job-con {
    padding: 0 20px;
  }
  table {
    margin: 0 auto;
    width: 960px;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    table-layout: fixed;
    word-break: break-all;
    background: #f0f0f0;
  }
  .u-label-title {
    font-weight: bold;
  }
  .demo-table {
    margin-top: 100px;
  }
  .expert-certify-ul {
    height: 100%;
  }
  .expert-certify-li {
    width: 25%;
  }
  .certify-li-cell {
    border-left: 1px solid #999;
    border-top: 1px solid #999;
  }
  .certify-li-cell-num {
    border-top: none;
  }
  .fistCertify {
    .certify-li-cell {
      border-left: none;
    }
  }
  .el-textarea__inner,
  .el-input__inner {
    border: none;
    font-size: 16px;
    color: #000;
  }
  .input-edu .el-input__inner {
    height: 82px;
    line-height: 82px;
  }
  .el-textarea__inner:focus {
    border: none;
  }
  .el-input__inner:focus {
    border: none;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
  table td {
    border-left: 1px solid #999;
    border-top: 1px solid #999;
    text-align: center;
  }
  .label-opinion-title {
    padding: 10px;
    text-align: left;
  }
  .sp-mark-label {
    color: red;
  }
  .h4-major-title {
    padding: 10px 0;
  }
  td {
    height: 40px;
    // width: 76.9px;
    font-size: 16px;
  }
}
</style>
